export const createLivePhotoCategory = new Map([
  //类别： 1-身份证正面 2-身份证反面 3-手持身份证 4-营业执照副本 5-法人身份证正面 6-法人身份证反面 7-食品经营许可 8-拍卖经营许可
  [
    1,
    {
      title: '身份证头像面照片',
      desc: '*请用手机横向拍摄以保持图片正常显示',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/2cef11ffb2ad6476b4cc3f949a10ef1e.jpg',
    },
  ],
  [
    2,
    {
      title: '身份证国徽面照片',
      desc: '*请用手机横向拍摄以保持图片正常显示',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/97d4b45f161fdc94ff4840f171434f1e.jpg',
    },
  ],
  [
    3,
    {
      title: '手持身份证照片',
      desc: '*拍照时请对焦在证件上（屏幕对着身份证按一下）',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/b5b0b783cf9b6d15abee2d1a7a0ba29e.jpg',
    },
  ],
  [
    4,
    {
      title: '营业执照副本照片',
      desc: '*上传营业执照照片',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/fcd5db102e1d92b327cfba9845a27e2f.jpg',
    },
  ],
  [
    5,
    {
      title: '法人身份证头像面照片',
      desc: '*请用手机横向拍摄以保持图片正常显示',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/2cef11ffb2ad6476b4cc3f949a10ef1e.jpg',
    },
  ],
  [
    6,
    {
      title: '法人身份证国徽面照片',
      desc: '*请用手机横向拍摄以保持图片正常显示',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/97d4b45f161fdc94ff4840f171434f1e.jpg',
    },
  ],
  [
    7,
    {
      title: '开户许可证',
      desc: '',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/28bdd35df1cd7c9e62fca23f48067f11.jpg',
    },
  ],
  [
    8,
    {
      title: '拍卖经营批准证书/文物拍卖许可证（拍卖行入驻必填）',
      desc:
        '*店铺名不带“拍卖”字样的商家无需上传此证书；授权类型需:提交授权书、拍卖公司营业执照、拍卖经营许可证点击下载',
      exampleUrl:
        'https://img.zai-art.com/zaiart/saas/image/md/8088d87da323bab183d533d697d8ac3c.jpg',
    },
  ],
]);
